import { observable, computed, action, makeObservable } from 'mobx';
import { create } from 'mobx-persist';

import ViewStore from './ViewStore';
import JobStore from './JobStore';
import VehicleStore from './VehicleStore';
import AuthStore from './AuthStore';
import GroupStore from './GroupStore';
import PolicyStore from './PolicyStore';
import RoleStore from './RoleStore';

import AccountStore from './AccountStore';
import CampaignStore from './CampaignStore';
import SiteStore from './SiteStore';
import BlueprintStore from './BlueprintStore';
import { UserAccessPosition } from '@vromo/api';


const hydrate = create();

export class RootStore {
    authStore = new AuthStore();
    /** Keeps track of global UI state e,g, selected drivers and jobs, sorting, filtering */
    viewStore = new ViewStore();

    // WebSocket stores
    jobStore = new JobStore(this);
    vehicleStore = new VehicleStore(this);
    groupStore = new GroupStore();
    policyStore = new PolicyStore();
    accountStore = new AccountStore();
    campaignStore = new CampaignStore();

    siteStore = new SiteStore();
    blueprintStore = new BlueprintStore();
    roleStore = new RoleStore();

    constructor() {
        makeObservable(this, {
            authStore: observable,
            viewStore: observable,
            jobStore: observable,
            vehicleStore: observable,
            groupStore: observable,
            policyStore: observable,
            accountStore: observable,
            campaignStore: observable,
            siteStore: observable,
            blueprintStore: observable,
            roleStore: observable,
            permissions: computed,
            clear: action,
            changeRole: action
        });

        hydrate('viewStore', this.viewStore);
    }

    get permissions(): { create: boolean, edit: boolean, delete: boolean, account: boolean } {

        switch (this.authStore?.role?.position?.id) {
            case UserAccessPosition.user:
                return {
                    create: true,
                    edit: true,
                    delete: false,
                    account: false
                };
            case UserAccessPosition.client:
                return {
                    create: false,
                    edit: false,
                    delete: false,
                    account: false
                };
            case UserAccessPosition.admin:
            default:
                return {
                    create: true,
                    edit: true,
                    delete: true,
                    account: true
                };
        }
    }

    clear = (): void => {
        this.authStore = new AuthStore();
        this.viewStore = new ViewStore();
        this.jobStore = new JobStore(this);
        this.vehicleStore = new VehicleStore(this);
        this.groupStore = new GroupStore();
        this.policyStore = new PolicyStore();
        this.accountStore = new AccountStore();
        this.campaignStore = new CampaignStore();
        this.siteStore = new SiteStore();
        this.roleStore = new RoleStore();
    };

    /** change role / acount, needs to fetch, receive all data from BE */
    changeRole = (): void => {

        this.siteStore.loaded = false
        this.blueprintStore.loaded = false
        this.roleStore.loaded = false
        this.groupStore.loaded = false
        this.campaignStore.loaded = false
        this.policyStore.loaded = false
        this.vehicleStore.loaded = false
        this.jobStore.loaded = false
        this.viewStore.filters.jobs.clear();
        this.viewStore.filters.drivers.clear();
    }


}

const rootStore = new RootStore();

declare global {
    interface Window {
        rootStore: RootStore;
    }
}
window.rootStore = rootStore;

export default rootStore;
